"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assignUsersToOrganization = assignUsersToOrganization;
exports.createOrganization = createOrganization;
exports.getAllOrganizations = getAllOrganizations;
exports.getOrganizationById = getOrganizationById;
exports.updateOrganizationById = updateOrganizationById;
exports.uploadFile = uploadFile;
require("core-js/modules/es.object.keys.js");
var _request = _interopRequireDefault(require("@/utils/request"));
function getAllOrganizations(token, query) {
  var headers = {
    'Authorization': 'Bearer ' + token
  };

  // 配置请求参数
  var config = {
    url: '/v1/organizations',
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'get',
    headers: headers
  };

  // 当query存在且非空时，才添加params配置
  if (query && Object.keys(query).length > 0) {
    config.params = query;
  }
  return (0, _request.default)(config);
}
function getOrganizationById(token, id) {
  var headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/v1/organizations/' + id,
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'get',
    headers: headers
  });
}
function createOrganization(token, formData) {
  var headers = {
    'Authorization': 'Bearer ' + token
  };
  var data = formData;
  return (0, _request.default)({
    url: '/v1/organizations',
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'post',
    headers: headers,
    data: data
  });
}
function updateOrganizationById(token, id, formData) {
  var headers = {
    'Authorization': 'Bearer ' + token
  };
  var data = formData;
  return (0, _request.default)({
    url: "/v1/organizations/".concat(id),
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'put',
    headers: headers,
    data: data
  });
}
function uploadFile(token, id, fileData) {
  var headers = {
    'Authorization': 'Bearer ' + token,
    'Content-Type': 'multipart/form-data'
  };
  return (0, _request.default)({
    url: "/v1/organizations/".concat(id, "/logo"),
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'post',
    data: fileData,
    headers: headers
  });
}
function assignUsersToOrganization(token, formData) {
  var headers = {
    'Authorization': 'Bearer ' + token
  };
  var data = formData;
  return (0, _request.default)({
    url: "/users/assign-to-organization",
    baseURL: process.env.VUE_APP_BASE_AUTH_API,
    method: 'post',
    headers: headers,
    data: data
  });
}